<template>
  <div :style="arrowContainerStyle">
    <el-tooltip :disabled="!arrowHead" class="item" effect="light" placement="top">
      <div slot="content">{{arrowText}}<br/>{{arrowParam.title}}</div>
      <div :style="arrowBoxStyle" @click="arrowClickFn" class="arrowContainer">
        <div v-if="arrowHead" :style="iconStyle[arrowParam.later_state]" class="arrowIcon">
          {{ arrowParam.later_state.slice(0, 1).toUpperCase() }}</div>
        <div class="arowLeft" v-else :style="arowLeftStyle"></div>
        <div class="arrowContent" :style="arrowContentStyle">
          {{ arrowText }} {{arrowParam.title}}
        </div>
        <div class="arowRight" :style="arowRightStyle"></div>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    arrowStyle: {
      type: Object,
      default: () => {
        return {
        };
      },
    },
    arrowText: {
      type: String,
      default: () => {
        return "";
      },
    },
    arrowClick: {
      type: Function,
      default: () => {
        return () => { };
      },
    },
    arrowHead: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    arrowParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      iconStyle: {
        running: {
          background: '#409EFF',
        },
        pending: {
          background: '#909399',
        },
        finish: {
          background: '#67C23A',
        },
      }
    };
  },
  computed: {
    arrowHeight: function () {
      return this.arrowStyle.height / 2;
    },
    arrowContainerStyle: function () {
      let str = `font-size:${this.arrowStyle.fontSize}px;font-weight:${this.arrowStyle.fontWeight};color:${this.arrowStyle.color};`;
      str +=
        this.arrowParam.later_state === "finish" ? "margin-right:10px;" : "";
      return str;
    },
    arrowContentStyle: function () {
      let str = `width:${this.arrowStyle.width ? this.arrowStyle.width + "px" : "auto"
        };`;
      if (this.arrowHead) {
        str += `text-align:left;margin-left:15px;font-weight:bold;color:#666;`;
      }
      return str;
    },
    arrowBoxStyle: function () {
      return `background:${this.arrowStyle.background};height:${this.arrowStyle.height
        }px;margin-right:${this.arrowHeight}px;padding-left:${this.arrowHead ? "0" : this.arrowHeight
        }px;`;
    },
    arowRightStyle: function () {
      return `border-left-color:${this.arrowStyle.background};border-left-width:${this.arrowHeight}px;border-top-width:${this.arrowHeight}px;border-bottom-width:${this.arrowHeight}px;right:-${this.arrowHeight}px;`;
    },
    arowLeftStyle: function () {
      return `border-left-width:${this.arrowHeight}px;border-top-width:${this.arrowHeight}px;border-bottom-width:${this.arrowHeight}px;right:-${this.arrowHeight}px;width:${this.arrowHeight}px;`;
    },
  },
  methods: {
    arrowClickFn() {
      this.arrowClick(this.arrowParam);
    },
  },
};
</script>
<style lang="scss" scoped>
.arrowContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  min-width: 100px;
  height: 80px;
  color: #fff;
  //   box-shadow: 0px 0px 0px 25px #ffffff inset;
  // padding-right: 15px;
  margin: 5px 0;
  // max-width: 200px;
  width: max-content;
  word-break: break-all;

  &:hover {
    cursor: pointer;
  }

  .arrowIcon {
    position: absolute;
    left: 0;
    top: 0;
    width: 12px;
    height: 12px;
    border-radius: 0 0 12px 0;
    color: #fff;
    line-height: 12px;
    text-align: center;
    padding: 0 2px 2px 0;
    font-size: 10px;
  }

  .arowRight {
    display: inline-block;
    position: absolute;
    right: -40px;
    border-left: 40px solid rgb(244, 244, 245);
    border-top: 40px solid transparent;
    border-bottom: 40px solid transparent;
  }

  .arowLeft {
    display: inline-block;
    position: absolute;
    left: 0;
    border-left: 40px solid #ffffff;
    border-top: 40px solid transparent;
    border-bottom: 40px solid transparent;
  }

  .arrowContent {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    width: auto;
    -webkit-line-clamp: 2;
  }
}
</style>